//https://deepinder.me/creating-a-real-time-chat-app-with-vue-socket-io-and-nodejs

import { io } from 'socket.io-client';

class SocketioService {
    counter = 0;
    items = [];
    photos = [];
    socket;
    constructor() {}

    setupSocketListeners() {
        this.setupScoreSocketListener();
        //this.setupPhotoSocketListener();
    }
    setupScoreSocketListener() {
        //for receiving the message
        this.socket.on('broadcast_control', (data) => {
            //console.log('receiving new message: ' + data);
            try {
                var json = JSON.parse(data);
                this.items.push(json);
            } catch(ex) {
                console.log(ex);
            }
        });
    }
    removeScoreSocketListener() {
        //
        //
    }
    setupPhotoSocketListener() {
        //for receiving the message
        this.socket.on('photo_control', (photo) => {
            //console.log('receiving new photo',photo);
            this.counter++;
            try {
                //var json = JSON.parse(photo);
                photo.datetimestamp = new Date().toString();
                this.photos.push(photo);
            } catch(ex) {
                console.log("socketio.service error");
                console.log(ex);
            }
            //garbage collection
            if (this.counter == 10) {
                this.photos = this.filter(function(obj) { //remove older than 10 seconds
                    return new Date(obj.datetimestamp) < new Date(Date.now() - 10000);
                });
                this.counter = 0;
            }
        });
    }
    removePhotoSocketListener() {
        //
        //
    }
    setupSocketConnection() {
        //called from AppJs
        console.log("socket setupSocketConnection();")
        var debugMode = (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false);
        var socket_endpoint = (debugMode ? process.env.VUE_APP_SOCKET_ENDPOINT_DEBUG : process.env.VUE_APP_SOCKET_ENDPOINT)

        this.socket = io(socket_endpoint);
        this.setupScoreSocketListener(); //maybe only call this on the display page?
        //this.setupPhotoSocketListener(); //maybe only call this on the display page?
    }
    //for sending the message
    emitBroadcastControlItem(item) {
        //console.log('sending new message: ' + item);
        this.socket.emit('broadcast_control', item);
    }
    //for sending the photo, not used, api gets POST and does io.emit('photo_control', msg);
    emitPhotoControlItem(item) {
        //console.log('sending new message: ' + item);
        this.socket.emit('photo_control', item);
    }
    disconnect() {
        console.log("socket disconnect();")
        if (this.socket) {
            this.socket.disconnect();
        }
    }    
}

export default new SocketioService();